/**
 * Infinite scroll / "Load more" for collection pages
 * Replaces pagination with a "Voir plus" button + auto-load on scroll
 */
(function () {
  const SCROLL_THRESHOLD = 400;
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  const pagination = document.querySelector('.pagination-wrapper, .pagination');
  if (!pagination) return;

  const nextLink = pagination.querySelector('a[rel="next"], .pagination__item--next a');
  if (!nextLink) {
    pagination.style.display = 'none';
    return;
  }

  // Replace pagination with "Voir plus" button
  pagination.innerHTML = '';
  const wrapper = document.createElement('div');
  wrapper.className = 'load-more-wrapper';

  const button = document.createElement('button');
  button.className = 'load-more-btn';
  button.textContent = 'Voir plus';
  button.dataset.nextUrl = nextLink.href;

  const spinner = document.createElement('div');
  spinner.className = 'load-more-spinner';
  spinner.style.display = 'none';

  wrapper.appendChild(button);
  wrapper.appendChild(spinner);
  pagination.appendChild(wrapper);
  pagination.style.display = '';

  let loading = false;
  let noMore = false;

  async function loadMore() {
    if (loading || noMore) return;
    loading = true;

    const url = button.dataset.nextUrl;
    if (!url) { noMore = true; return; }

    button.style.display = 'none';
    spinner.style.display = 'block';

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new product items
      const newGrid = doc.getElementById('ProductGridContainer');
      if (newGrid) {
        const newItems = newGrid.querySelectorAll('.grid__item, .collection-product-card');
        const currentGrid = container.querySelector('ul.grid, .product-grid');

        if (currentGrid && newItems.length > 0) {
          newItems.forEach(function (item) {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            currentGrid.appendChild(item);
            // Trigger fade-in
            requestAnimationFrame(function () {
              item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        }
      }

      // Check for next page
      const newPagination = doc.querySelector('.pagination-wrapper, .pagination');
      const newNext = newPagination
        ? newPagination.querySelector('a[rel="next"], .pagination__item--next a')
        : null;

      if (newNext) {
        button.dataset.nextUrl = newNext.href;
        button.style.display = '';
      } else {
        noMore = true;
        wrapper.style.display = 'none';
      }
    } catch (e) {
      button.style.display = '';
      button.textContent = 'Réessayer';
    }

    spinner.style.display = 'none';
    loading = false;
  }

  // Click handler
  button.addEventListener('click', loadMore);

  // Auto-load on scroll (optional — triggers when near bottom)
  function onScroll() {
    if (noMore || loading) return;
    const rect = wrapper.getBoundingClientRect();
    if (rect.top < window.innerHeight + SCROLL_THRESHOLD) {
      loadMore();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
